import * as Backbone from 'backbone';
import Loader from 'sma.admin/components/loader';

const ajax = require('sma.common/ajax');
const Alert = require('sma.admin/components/alert');

let baseModalTempl = require('sma.admin/components/partials/modals/base.mustache');
let buttonTempl = require('sma.admin/components/partials/modals/button.mustache');
let promptPartial = require('sma.admin/components/partials/modals/prompt.mustache');
let deleteStatusPartial = require('sma.admin/components/partials/modals/delete_custom_status.mustache');
let checkboxPartial = require('sma.admin/components/partials/modals/checkbox.mustache');

class Content {
	constructor(options) {
		this.html = options.html;
		this.events = options.events || {};
		this.title = options.title || '';
		this.subtitle = options.subtitle || '';
		this.buttons = options.buttons || [];
		this.modal = options.modal;
		this.extraData = {};
	}

	get isDelayed() {
		return false;
	}

	setHtml(html) {
		this.html = html;
	}

	onSwitchTo(_modal, _id, _reRender = true) { }

	onSwitchOut(_modal, _id) { }

	onRendered(_modal) { }
}

class Modal extends Backbone.View {
	get cls() {
		return 'sma-modal sma-automation-popup-modal';
	}

	handleOptions(options) {
		options = options || {};

		this.title = options.title || '';
		this.subtitle = options.subtitle || '';
		this.size = options.size || 'md';
		this.buttons = options.buttons || [];
		this.overwriteFooter = options.overwriteFooter || false;

		this.destroyCallback = options.destroyCallback || null;

		this.onShow = options.onShow || function () { return; };
		this.onHide = options.onHide || function () { return; };
		this.autoShow = options.autoShow || false;
		this.destroyOnClose = options.destroyOnClose || false;
		this.async = options.async || false;
		this.useButtonLoaders = options.useButtonLoaders || false;
		this.onClose = options.onClose || function () { return; };

		this.modalHeaderTemplate = options.headerTemplate || null;
		this.modalHeaderContext = options.headerContext || {};

		this.bodyClass = options.bodyClass || '';
		this.fromModal = options.fromModal || false;
	}

	render() {
		this.outerWrap = $('<div class="sma-modal-outer-wrap"></div>')
			.appendTo('body')
			.hide();

		let baseCtxt = {
			title: this.title,
			subtitle: this.subtitle,
			size: this.size,
			cls: this.cls,
			strings: {
				close: gettext('Close')
			}
		};

		this.wrap = $(baseModalTempl(baseCtxt));

		this.modalShade = $('<div class="sma-modal-shade"></div>');
		this.modalWindow = $('.sma-modal', this.wrap);
		this.modalBody = $('.sma-modal-content', this.wrap);
		this.modalFooter = $('.sma-modal-footer', this.wrap);
		this.modalClose = $('.sma-modal-close', this.wrap);
		this.modalHeader = $('.sma-modal-header', this.wrap);

		if (this.bodyClass) {
			this.modalBody.addClass(this.bodyClass);
		}

		if (this.modalHeaderTemplate !== null) {
			this.modalHeader.html(this.modalHeaderTemplate($.extend(baseCtxt, this.modalHeaderContext)));
		}

		if (this.buttons !== undefined && this.buttons.length) {
			this.renderButtons();
		}

		this.modalShade.appendTo('body');
		this.modalBody.append(this.$el);
		this.wrap.appendTo(this.outerWrap);

		this.modalClose.click((e) => {
			this.closeModal(e);
		});

		if (this.autoShow) {
			this.show();
		}
	}

	closeModal(e) {
		if (e) {
			e.preventDefault();
		}

		this.onClose();

		if (this.previouslyFocusedElement) {
			$(this.previouslyFocusedElement).focus();
		}

		this.onClose();

		this.hide();
	}

	renderButtons() {
		const that = this;
		this.modalFooter.empty();

		if (this.buttons.length > 0) {
			this.modalFooter.show();
			this.modalBody.removeClass('sma-modal-no-footer');

			for (const cfg of this.buttons) {
				(function (buttoncfg) {
					const button = $(buttonTempl({
						...buttoncfg,
						useButtonLoaders: that.useButtonLoaders,
						cls: that.useButtonLoaders ? `${buttoncfg.cls} btn-with-loader` : buttoncfg.cls,
					}));

					if (that.useButtonLoaders && cfg.footerLoader === undefined) {
						cfg.footerLoader = new Loader(button.find('.btn-loader')[0], 'sm');
						cfg.footerLoader.hide();
					}

					button.click(() => {
						if (that.useButtonLoaders) {
							button.find('.btn-label')[0].classList.add('invisible');
							button.attr('disabled', 'disabled');
							cfg.footerLoader.show();
						}
						return buttoncfg.handler(that);
					});

					that.modalFooter.append(button);
					cfg.htmlNode = button;
				})(cfg);
			}

			for (const button of this.buttons) {
				button.hideLoader = () => {
					if (this.useButtonLoaders) {
						button.footerLoader.hide();
						button.htmlNode.find('.btn-label')[0].classList.remove('invisible');
						button.htmlNode.removeAttr('disabled');
					}
				};
			}
		} else {
			this.modalFooter.hide();
			if (!this.overwriteFooter) {
				this.modalBody.addClass('sma-modal-no-footer');
			}
		}
	}

	setTitle(title, subtitle = null) {
		$('.sma-modal-title', this.wrap).html(title);
		if (subtitle !== null) {
			$('.sma-modal-subtitle', this.wrap).html(subtitle);
		}
	}

	setContent(content) {
		this.modalBody.html(content);
	}

	setButtons(buttons) {
		this.buttons = buttons;
		this.renderButtons();
	}

	show() {
		this.outerWrap.addClass('open');
		this.outerWrap.show();

		this.modalShade.show();

		this.modalWindow.css({
			opacity: 0
		}).show().animate({
			opacity: 1
		}, 200, () => {
			$(document).trigger('smaModalShown', [this]);
		});

		this.onShow();

		let focusableElements = this.modalWindow.find(':tabbable:visible');

		let firstFocusableElement = focusableElements.first();
		let lastFocusableElement = focusableElements.last();

		lastFocusableElement.on('keydown', function (e) {
			if ((e.which === 9 && !e.shiftKey)) {
				e.preventDefault();
				firstFocusableElement.focus();
			}
		});

		firstFocusableElement.on('keydown', function (e) {
			if ((e.which === 9 && e.shiftKey)) {
				e.preventDefault();
				lastFocusableElement.focus();
			} else if (e.which === 9 && focusableElements.get(1)) {
				e.preventDefault();
				focusableElements.get(1).focus();
			}
		});

		$(document).on('keydown', (e) => {
			if (e.keyCode == 27) {
				this.closeModal();
			}
		});

		this.previouslyFocusedElement = document.activeElement;

		// If there's nothing to focus in the body of the modal, set focus on the first tabbable item on the modal

		if (this.modalBody.find(':tabbable:visible').length > 0) {
			this.modalBody.find(':tabbable:visible').first().focus();
		} else {
			firstFocusableElement.focus();
		}


		if (this.fromModal) {
			const zindex = this.modalBody.parents('.sma-modal-outer-wrap').css('z-index');
			this.modalBody.parents('.sma-modal-outer-wrap').css('z-index', zindex + 1);
		}

		$('html').css('overflow', 'hidden');
	}

	hide(destroy) {
		if (this.onHide) this.onHide();
		this.outerWrap.hide();
		this.outerWrap.removeClass('open');
		this.modalShade.hide();

		this.modalWindow.animate({
			opacity: 0
		}, 200, () => {
			if (destroy || this.destroyOnClose) {
				this.destroy();
			} else {
				this.modalWindow.hide();
			}
		});

		$('html').css('overflow', 'auto');

		$(document).trigger('smaModalHide', [this]);
	}

	destroy() {
		$('html').css('overflow', 'auto');
		this.outerWrap.remove();
		this.wrap.remove();
		this.modalShade.remove();
		if (this.destroyCallback !== null) {
			this.destroyCallback();
		}
	}

	hideDestroy({callback, callbackData} = {}) {
		this.hide();

		setTimeout(() => {
			this.destroy();
			if (callback) {
				callback(callbackData);
			}
		}, 1000);
	}
}

class MultiModal extends Modal {
	constructor(options) {
		super(options);
		this.handleOptions(options);

		this.stack = [];
		this.history = [];
		this.boundEvents = [];
		this.currentContent = null;

		this.render();
	}

	closeModal(e) {
		if (e) {
			e.preventDefault();
		}

		this.onClose();

		if (this.history.length > 1) {
			this.back();
		} else {
			if (this.previouslyFocusedElement) {
				$(this.previouslyFocusedElement).focus();
			}

			this.hide();
		}
	}

	addToStack(id, content, switchTo = false) {
		this.stack.push({
			id: id,
			content: content
		});

		if (this.stack.length == 1 || switchTo) {
			this.switchToContent(id);
		}
	}

	getStackItemById(id) {
		for (let stackItem of this.stack) {
			if (stackItem.id == id) {
				return stackItem;
			}
		}
		return null;
	}

	getCurrentContent() {
		let currentContent = this.getStackItemById(this.currentContent);
		return currentContent.content;
	}

	updateModalContent(content) {
		this.setButtons(content.buttons);
		this.setTitle(content.title, content.subtitle);
		this.setContent(content.html);
		this.bindEvents(content);
		content.onRendered(this);
	}

	switchToContent(id, saveToHistory = true, reRender = true) {
		let stackItem = this.getStackItemById(id);
		if (stackItem == null) {
			return;
		}

		if (!stackItem.content.isDelayed) {
			this.updateModalContent(stackItem.content);
		}

		if (this.currentContent != null) {
			let oldItem = this.getStackItemById(this.currentContent.id);
			if (oldItem != null) {
				oldItem.content.onSwitchOut(this, this.currentContent.id);
			}
		}
		let oldContent = this.currentContent;

		this.currentContent = stackItem.id;
		stackItem.content.onSwitchTo(this, stackItem.id, reRender);

		if (saveToHistory) {
			if (this.history.indexOf(stackItem.id) > -1) {
				this.history.pop(oldContent.id);
			} else {
				this.history.push(stackItem.id);
			}
		}
	}

	back(pop = true) {
		if (this.history.length <= 1) {
			return;
		}

		let nextContentId = this.history[this.history.length - 2];
		if (pop) {
			this.history.pop();
		}
		this.switchToContent(nextContentId, false);
	}

	unbindEvents() {
		for (let event of this.boundEvents) {
			if (event.length == 1) {
				this.modalWindow.off(event);
			} else {
				this.modalWindow.off(event[0], event[1]);
			}
		}

		this.boundEvents.length = 0;
		this.boundEvents = [];
	}

	bindEvents(content) {
		if (content === undefined || content === null) {
			return;
		}

		this.unbindEvents();

		for (let eventSelector in content.events) {
			let handler = content.events[eventSelector];

			let splitSelector = eventSelector.split(' ');

			if (typeof (handler) == 'string') {
				handler = $.proxy(content[handler], content);
			}

			if (splitSelector.length == 1) {
				this.modalWindow.on(splitSelector, handler);
			} else {
				this.modalWindow.on(splitSelector[0], splitSelector[1], handler);
			}

			if (splitSelector !== null) {
				this.boundEvents.push(splitSelector);
			}
		}
	}
}

export class ContentModal extends Modal {
	constructor(content, options) {
		super();

		this.handleOptions(options);

		this.element = content;

		if (content instanceof jQuery) {
			content = content[0];
		}
		this.setElement(content);
		this.render();
	}
}

class AjaxFormContent extends Content {
	constructor(url, options) {
		super(options);
		this.url = url;
		this.responseData = null;
		this.onLoad = options.onLoad || function () { };
		this.onError = options.onError || function () { };
		this.footerContent = null;
		this.alwaysCallback = options.alwaysCallback || false;
	}

	get isDelayed() {
		return true;
	}

	onSwitchTo(modal, stackItemId, reRender = true) {
		if (!reRender && this.html) {
			modal.updateModalContent(this);
			// If the buttons are configured in JS
			if (!modal.buttons.length) {
				modal.modalFooter.html(this.footerContent);
				modal.modalFooter.show();
			}
			return;
		}
		const options = {
			url: this.url,
			data: this.extraData,
			alertOnSuccess: false,
			alwaysCallback: this.alwaysCallback,
			contentType: 'json',
			headers: {
				Accept: 'application/json',
			},
			callback: (response) => {
				if (response.success == false) {
					this.onError(response);
					return;
				}
				// Shouldn't use ids in dynamic content
				if ($(response.html).find('#modal-title').length > 0) {
					this.title = $(response.html)
						.find('#modal-title')
						.html();
				}
				this.responseData = response;
				this.html = response.html;

				// follow ajax-modal links
				this.events['click a.ajax-modal'] = (e) => {
					e.preventDefault();
					let $modalLink = $(this);
					let newSize = $modalLink.data('size') || modal.size;
					modalUrl[0] = $modalLink.attr('href');

					$.get(modalUrl[0], function (response) {
						if (response.redirect) {
							modal.onSuccess(response);
							modal.hide();
						} else {
							let title = $(response.html)
								.find('#modal-title')
								.html();
							let sizeClass = 'sma-modal-' + modal.size;
							let newSizeClass = 'sma-modal-' + newSize;
							let $sizeElement = modal.wrap.find('.' + sizeClass);

							$sizeElement.removeClass(sizeClass);
							$sizeElement.addClass(newSizeClass);
							modal.setTitle(title);
							modal.setContent(response.html);
						}
					});
				};

				// Submit forms using ajax
				// This is an ie fix
				let ua = window.navigator.userAgent;
				if (ua.indexOf('MSIE ') > -1 || ua.indexOf('rv:11.0') > -1 || ua.indexOf(' Edge') > -1) {
					this.events['click [type="submit"]'] = (e) => {
						modal.onSubmit(e);
					};
				} else {
					this.events['submit form'] = (e) => {
						modal.onSubmit(e);
					};
				}

				this.events['click [data-dismiss="modal"]'] = (_e) => {
					modal.hide();
				};

				modal.setTitle(this.title);
				modal.setContent(this.html);

				if (this.buttons.length) {
					// If the buttons are configured in JS
					modal.setButtons(this.buttons);
				} else {
					// If the buttons come from the servers in its own footer
					const footerSelector = '.sma-modal-footer';
					this.footerContent = modal.modalBody.find(footerSelector).html();
					modal.modalFooter.html(this.footerContent);
					modal.modalBody.find(footerSelector).remove();
					modal.modalFooter.show();
				}
				modal.bindEvents(this);
				this.onRendered(modal);
				this.onLoad();
			}
		};
		ajax.get(options);
	}
}

class AjaxFormModal extends MultiModal {
	constructor(options) {
		super(options);
		options = options || {};
	}

	onSubmit(e) {
		if (e) {
			e.preventDefault();
		}

		const $form = this.modalBody.find('form');
		const $button = $(document.activeElement);

		// include submit button name/value if present
		if (
			$button.length &&
			$form.has($button) &&
			$button.is('[name]') &&
			$button.is('button[type="submit"], input[type="submit"], input[type="image"]')
		) {
			$('<input type="hidden" value="" />')
				.attr('name', $button.attr('name'))
				.attr('value', $button.val())
				.prependTo($form);
		}
		const formData = new FormData($form[0]);
		const currentContent = this.getCurrentContent();

		const options = {
			method: 'POST',
			url: currentContent.url,
			data: formData,
			async: this.async,
			cache: false,
			contentType: false,
			headers: {
				Accept: 'application/json',
			},
			processData: false,
			alwaysCallback: true,
			alertOnSuccess: false,
			alertOnError: false,
			callback: (response) => {
				if (response.html) {
					const footerSelector = '.sma-modal-footer';
					this.modalBody.html($(response.html));
					this.modalFooter.html(this.modalBody.find(footerSelector).html());
					this.modalBody.find(footerSelector).remove();
					currentContent.onLoad();
				}
				if (this.useButtonLoaders) {
					// Response received, so stop all loaders on buttons
					this.buttons.map(button => button.hideLoader());
				}
				if (response.success) {
					this.onSuccess(response);
				}
				if (response.nextContentId) {
					this.switchToContent(response.nextContentId);
				}
			},
			onFail: (xhr) => {
				const response = xhr.responseJSON;
				if (response) {
					this.modalBody.html($(response.html));
				} else {
					new Alert({
						type: 'danger',
						message: gettext('Unknown error occured'),
					});
				}
			},
		};

		ajax.post(options);
	}

	handleOptions(options) {
		options = options || {};
		super.handleOptions(options);
		this.onSuccess = (response) => {
			if (response.redirect !== undefined) {
				window.location.href = response.redirect;
			}
		};

		if (options.onSuccess) {
			this.onSuccess = options.onSuccess.bind(this);
		}
	}
}

class URLModal extends Modal {
	constructor(url, options) {
		super();

		this.url = url;
		this.handleOptions(options);

		let modal = this;

		$.get(this.url, function (response) {
			modal.element = response;
			modal.setElement(response);
			modal.render();
		},);
	}
}

class AjaxURLModal extends Modal {
	constructor(url, options) {
		super();

		this.url = url;
		this.handleOptions(options);

		let modal = this;

		$.get(this.url, function (response) {
			if (response.success) {
				modal.element = response.html;
				modal.setElement(response.html);
				modal.render();
			}
		});
	}
}

class TemplateModal extends Modal {
	get template() {
		throw 'Please override and provide a template';
	}

	constructor(options, ctx) {
		super();

		this.handleOptions(options);

		this.element = $(this.template(ctx));
		this.setElement(this.element[0]);

		this.render();
	}
}

class Prompt extends Modal {
	// Basic modal with a text input. The content of
	// the text box will get passed into your callback
	// function when clicking OK.
	get cls() {
		return 'sma-modal sma-modal-prompt sma-automation-popup-modal';
	}

	constructor(title, description, callback, options) {
		super();

		options = options || {};
		options.maxLength = options.maxLength || 200;

		this.handleOptions({
			title: title,
			destroyOnClose: true,
			buttons: [{
				cls: 'btn-link btn-loud',
				id: 'sma-btn-modal-cancel',
				label: gettext('Cancel'),
				type: 'button',
				handler: () => {
					this.hideDestroy();
				}
			}, {
				cls: 'btn-primary btn-loud sma-js-notify-ok',
				id: 'sma-btn-modal-ok',
				type: 'button',
				label: options.ok || gettext('OK'),
				handler: $.proxy(function () {
					let okButton = this.modalFooter.find('.sma-js-notify-ok');
					if (okButton.hasClass('disabled')) {
						return;
					}
					let value = this.modalBody.find('input[name="modal-prompt-input"]').val();
					this.hideDestroy({callback, callbackData: value});
				}, this)
			}]
		});

		this.element = promptPartial(
			{
				description: description,
				value: options.default_value,
				maxLength: options.maxLength,
				max_length_text: gettext('characters maximum'),
				title: title
			}
		);
		this.setElement(this.element);

		this.render();
		this.show();
	}
}

class CheckboxModal extends Modal {

	get cls() {
		return 'sma-modal sma-modal-checkbox sma-automation-popup-modal';
	}

	constructor(title, description, checkboxText, callback, options = {}) {
		super();

		let okLabel = gettext('OK');
		let buttonClass = 'btn-primary';

		if (options.isDelete) {
			okLabel = gettext('DELETE');
			buttonClass = 'btn-danger';
		}

		if (options.okLabel) {
			okLabel = options.okLabel;
		}

		if (options.buttonClass) {
			buttonClass = options.buttonClass;
		}

		this.handleOptions({
			title: title,
			destroyOnClose: true,
			onShow: options.onShow,
			buttons: [{
				cls: 'btn-default btn-loud',
				label: gettext('Cancel'),
				handler: () => {
					this.hideDestroy();
				}
			}, {
				cls: 'sma-js-modal-ok btn-loud ' + buttonClass,
				label: okLabel,
				handler: $.proxy(function () {
					let value = this.modalBody.find('.sma-js-modal-checkbox').is(':checked');
					this.hideDestroy({callback, callbackData: value});
				}, this)
			}]
		});

		this.element = checkboxPartial({
			description,
			checkboxText
		});

		this.setElement(this.element);

		this.render();

		if (options.contingent) {
			$('.sma-js-modal-ok').prop('disabled', true);
			$('.sma-js-modal-checkbox').change(() => {
				if (this.modalBody.find('.sma-js-modal-checkbox').is(':checked')) {
					$('.sma-js-modal-ok').prop('disabled', false);
				} else {
					$('.sma-js-modal-ok').prop('disabled', true);
				}
			});
		}

		this.show();
	}
}

class Notify extends Modal {
	get cls() {
		return 'sma-modal sma-modal-confirm sma-automation-popup-modal';
	}

	constructor(title, description, okText, callback) {
		super();

		this.handleOptions({
			title,
			destroyOnClose: true,
			buttons: [{
				cls: 'btn-default btn-loud',
				label: okText,
				handler: (value) => {
					this.hideDestroy({callback, callbackData: value});
				},
			}],
		});

		this.element = $('<div class="sma-modal-desc"></div>')
			.html(description);

		this.setElement(this.element[0]);

		this.render();
		this.modalClose.hide();

		this.show();
	}
}

class LargeNotify extends Notify {
	get cls() {
		return 'sma-modal sma-modal-confirm sma-modal-lg sma-automation-popup-modal';
	}
}

class Confirm extends Modal {
	get cls() {
		return 'sma-modal sma-modal-confirm sma-automation-popup-modal';
	}

	constructor(title, description, callback, options) {
		super();

		options = options || {};

		this.handleOptions({
			title: title,
			destroyOnClose: true,
			buttons: [{
				cls: options.no_class || 'btn-secondary',
				id: 'sma-btn-modal-no',
				label: options.no || gettext('No'),
				handler: () => {
					if (options.noCallback) {
						options.noCallback();
					}

					this.hideDestroy();
				}
			}, {
				cls: options.yes_class || 'btn-primary',
				id: 'sma-btn-modal-yes',
				label: options.yes || gettext('Yes'),
				handler: (value) => {
					this.hideDestroy({callback, callbackData: value});
				}
			}]
		});

		this.element = $('<div class="sma-modal-desc"></div>')
			.html(description);

		this.setElement(this.element[0]);

		this.render();
		this.show();
	}
}

class DeleteStatus extends Modal {
	get cls() {
		return 'sma-modal sma-modal-confirm sma-automation-popup-modal';
	}

	constructor(title, description, replacement, statuses, callback, options) {
		super();

		options = options || {};

		this.handleOptions({
			title: title,
			destroyOnClose: true,
			buttons: [{
				cls: 'btn-default',
				label: options.no || gettext('No'),
				handler: () => {
					this.hideDestroy();
				}
			}, {
				cls: 'btn-primary',
				label: options.yes || gettext('Yes'),
				handler: $.proxy(function (modal) {
					let value = modal.modalBody.find('select[name="new-status"]').val();
					modal.hideDestroy({callback, callbackData: value});
				})
			}]
		});
		this.element = deleteStatusPartial({
			description: description, replacement: replacement, statuses: statuses
		});

		this.setElement(this.element);

		this.render();
		this.show();
	}
}

module.exports = {
	Confirm,
	Modal,
	MultiModal,
	Content,
	ContentModal,
	AjaxFormModal,
	AjaxURLModal,
	AjaxFormContent,
	TemplateModal,
	URLModal,
	Prompt,
	Notify,
	LargeNotify,
	DeleteStatus,
	CheckboxModal,
};
